/**
 * Transform on scroll
 */

export default (() => {
  ;(function () {
    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max)
    }

    function getZoomDistance(item) {
      const value = item.dataset.zoomDistance

      if (!value) return window.innerHeight

      if (value.endsWith('vh')) {
        return (window.innerHeight * parseFloat(value)) / 100
      }

      return parseFloat(value) || window.innerHeight
    }

    function getPageProgress(zoomDistance) {
      return clamp(window.scrollY / zoomDistance, 0, 1)
    }

    function getSectionProgress(item, zoomDistance) {
      const rect = item.getBoundingClientRect()
      const start = window.innerHeight
      const current = start - rect.top

      return clamp(current / zoomDistance, 0, 1)
    }

    function prepareZoom() {
      const items = document.querySelectorAll('[data-zoom]')
      if (!items.length) return

      items.forEach(function (item) {
        const target = item.querySelector('[data-zoom-target]') || item

        target.style.willChange = 'transform'
        target.style.backfaceVisibility = 'hidden'
        target.style.transform = 'translate3d(0, 0, 0) scale(1)'
      })
    }

    function updateZoom() {
      const items = document.querySelectorAll('[data-zoom]')
      if (!items.length) return

      items.forEach(function (item) {
        const target = item.querySelector('[data-zoom-target]') || item

        const scaleFrom = parseFloat(item.dataset.scaleFrom) || 1
        const scaleTo = parseFloat(item.dataset.scaleTo) || 1.15
        const zoomDistance = getZoomDistance(item)
        const zoomMode = item.dataset.zoomMode || 'section'

        const progress =
          zoomMode === 'page'
            ? getPageProgress(zoomDistance)
            : getSectionProgress(item, zoomDistance)

        const scale = scaleFrom + (scaleTo - scaleFrom) * progress

        target.style.transform = 'translate3d(0, 0, 0) scale(' + scale + ')'
      })
    }

    window.addEventListener('scroll', updateZoom, { passive: true })
    window.addEventListener('resize', updateZoom)
    window.addEventListener('load', function () {
      prepareZoom()
      updateZoom()
    })

    prepareZoom()
    updateZoom()
  })()
})()
